import type { UseFormGetValues, UseFormRegister, UseFormSetValue } from "react-hook-form";

import { InputWithClear } from "@/components/form";
import { NotSpecialCharRegExp, removeUnexpectedChar } from "@/shared/regexps";
import { setStorage } from "@/shared/store";

// Patmo 的 序列号数据 的格式要求是 后四位必为数字
export default function PatmoSNInput({
  register,
  setValue,
  getValues,
  disabled,
  placeholder = "例：GBXNDL01234567",
}: Readonly<{
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<any>;
  disabled?: boolean;
  placeholder?: string;
}>) {
  const handleInputSerialNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cleaned = removeUnexpectedChar(e.target.value, NotSpecialCharRegExp).toString().substring(0, 50);
    setStorage("serialNumber", cleaned);
    setValue("serialNumber", cleaned);
  };

  return (
    <>
      <p className="mb-2 mt-2 text-[14px] font-medium leading-[100%] tracking-normal text-[#D42936]">
        集合玄関機に表示されている番号を入力してください。
      </p>
      <InputWithClear
        id="serialNumber"
        register={register("serialNumber", {
          onChange: handleInputSerialNumber,
          required: true,
          validate: (value: string) => {
            const first4 = value.slice(0, 4);
            if (/[0-9]/.test(first4)) {
              return "シリアル番号の形式が正しくありません";
            }
            return true;
          },
          pattern: {
            value: /^[a-zA-Z0-9]{4,46}[0-9]{4}$/,
            message: "シリアル番号の形式が正しくありません",
          },
        })}
        getValues={getValues}
        setValue={setValue}
        placeholder={placeholder}
        disabled={disabled}
      />
    </>
  );
}
